// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2mwRC","errors":"Errors_errors__1gats"};